<template>
    <div class="new">
        <section id="news" class="news section">
            <div class="container section-title" data-aos="fade-up">
                <h2>{{title}}</h2>
            </div>
            <div class="container justify-content-center">
                <section id="featured-services" class="featured-services section d-flex justify-content-center">
                    <div class="container">
                        <div class="row gy-4 justify-content-center">
                            <div class="col-xl-4 col-md-6 " data-aos="fade-up" data-aos-delay="100" v-for="item in dataNews" :key="item.id">
                                <div class="service-item position-relative d-flex flex-column align-items-center">
                                    <div class="mb-3">
                                        <img :src="gambarUrl + item.news" alt="News Image" class="img-fluid rounded-3 shadow-lg">
                                    </div>
                                    <h4 class="mb-2">
                                        <p>{{ item.title }}</p>
                                    </h4>
                                    <p class="text-center">{{ item.content.substring(0, 30) + '...' }}</p>
                                    <br>
                                    <button class="btn btn-fwi" @click="showNews(item.id)" data-bs-toggle="modal" data-bs-target="#newsModal">Selengkapnya</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div class="modal fade" id="newsModal" tabindex="-1" aria-labelledby="newsModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="newsModalLabel">Berita</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <div v-if="selectedNews">
                                    <h3 class="mb-3">{{ selectedNews.title }}</h3>
                                    <div class="d-flex align-items-center mb-3">
                                        <i class="bi bi-calendar-event-fill me-2"></i>
                                        <small>{{ new Date(selectedNews.created_on).toLocaleString('id-ID', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }) }}</small>
                                    </div>
                                    <img :src="gambarUrl + selectedNews.news" alt="News Image" class="img-fluid mb-4 rounded-3 align-items-center d-block mx-auto" style="max-width: 400px; height: 400px;">
                                    <div v-html="selectedNews.content.replace(/(\r\n|\n|\r)/gm, '<br>').replace(/<img src/g, '<img class=\'img-fluid rounded-3 align-items-center d-block mx-auto\' src')"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import NewsJs from './js/app.js';
export default NewsJs;
</script>